import currency from 'currency.js';

export function bankersRound(n?: number | string | null, d = 2) {
  if (!n) {
    return 0;
  }
  if (typeof n === 'string') {
    n = currency(n).value;
  }
  const x = n * 10 ** d;
  const lower = Math.floor(x);
  const isHalfTie =
    Math.abs(x - (lower + 0.5)) <= Number.EPSILON * Math.max(1, Math.abs(x));
  const br = isHalfTie ? (lower % 2 === 0 ? lower : lower + 1) : Math.round(x);
  return br / 10 ** d;
}

export function bankersRoundToCents(amount?: string | number) {
  return Math.round(bankersRound(amount) * 100);
}

export function floatToCents(amount?: string | number) {
  return bankersRoundToCents(amount);
}

export function centsToFloat(centAmount?: number) {
  return centAmount ? centAmount / 100 : 0;
}
